import loadable from "@loadable/component";
import { categoryList, LANDING_KEYS, LANDING_PAGES } from "@models";
import { ProtectedRoute, SharedSpinner } from "@shared";
import {
  Navigate,
  RouteObject,
  createBrowserRouter,
  useParams,
} from "react-router-dom";

const App = loadable(() => import("../../App"));

const Loadable = loadable(({ path }) => import(`../../scenes/${path}`), {
  cacheKey: ({ path }) => path,
  fallback: <SharedSpinner />,
});

const RedirectRequests = () => {
  const { tenantId } = useParams();

  switch (tenantId) {
    case "1":
      return <Navigate to={`/requests/deja-chupka/1`} replace />;
    case "5":
      return <Navigate to={`/requests/hm-aesthetics&dental/5`} replace />;
    case "7":
      return <Navigate to={`/requests/frizerski-salon-petko/7`} replace />;
    default:
      return <Navigate to="/404" replace />;
  }
};

const RedirectTenantCategories = () => {
  const { category } = useParams();

  if (!categoryList.includes(category || "")) {
    return <Navigate to="/404" replace />;
  }

  return <Loadable path="tenants" />;
};

const RedirectCityTenants = () => {
  const { category } = useParams();

  if (!categoryList.includes(category || "")) {
    return <Navigate to="/404" replace />;
  }

  return <Loadable path="tenants" />;
};

const protectedRoutes: RouteObject[] = [
  {
    path: "/my-bookings",
    element: <Loadable path="bookings" />,
  },
  {
    path: "/favorites",
    element: <Loadable path="favorites" />,
  },
  {
    path: "/my-profile",
    element: <Loadable path="account/profile" />,
  },
  {
    path: "/my-profile/edit",
    element: <Loadable path="account/profile/edit" />,
  },
  {
    path: "/password",
    element: <Loadable path="account/changePassword" />,
  },
];

const publicRoutes: RouteObject[] = [
  {
    path: "/forgot-password",
    element: <Loadable path="account/forgotPassword" />,
  },
  {
    path: "/reset-password",
    element: <Loadable path="account/resetPassword" />,
  },
  {
    path: "/activation",
    element: <Loadable path="account/activation" />,
  },
  {
    path: "/login",
    element: <Loadable path="login" />,
  },
  {
    path: "/registration",
    element: <Loadable path="registration" />,
  },
  {
    path: "/tenants/:category",
    element: <RedirectTenantCategories />,
  },
  {
    path: "/categories",
    element: <Loadable path="city" />,
  },
  {
    path: "/city/:citySlug",
    element: <Loadable path="city" />,
  },
  {
    path: "/city/:citySlug/:category",
    element: <RedirectCityTenants />,
  },
  {
    path: "/pricing/:tenancyName/:tenantId",
    element: <Loadable path="priceList" />,
  },
  {
    path: "/requests/:tenantId",
    element: <RedirectRequests />,
  },
  {
    path: "/requests/:tenancyName/:tenantId",
    element: <Loadable path="requests" />,
  },
  {
    path: "/blog",
    element: <Loadable path="blog" />,
  },
  {
    path: "/blog/:slug",
    element: <Loadable path="blog/post" />,
  },
  // Statične landing stranice (/cene, /za-frizere, /contact …). Putanje se
  // izvode iz SEO rečnika, koji određuje i šta prerender upisuje u `dist/` i
  // u sitemap — dve odvojene liste bi značile da build objavi stranicu koju
  // ruter pošalje na /404. Ključ rečnika je ujedno ime scene foldera.
  ...LANDING_KEYS.map((key) => ({
    path: LANDING_PAGES[key].path,
    element: <Loadable path={key} />,
  })),
  {
    path: "/announcements",
    element: <Loadable path="announcements" />,
  },
  {
    path: "/promotions",
    element: <Loadable path="promotions" />,
  },
  {
    path: "/privacy-policy",
    element: <Loadable path="privacyPolicy" />,
  },
  {
    path: "/terms-of-service",
    element: <Loadable path="termsOfService" />,
  },
  {
    path: "/",
    element: <Loadable path="categories" />,
  },
  {
    path: "/404",
    element: <Loadable path="shared/notFound" />,
  },
  {
    path: "*",
    element: <Loadable path="shared/notFound" />,
  },
];

export const routes: RouteObject[] = [
  {
    element: <App key="app" />,
    children: [
      ...publicRoutes,
      {
        element: <ProtectedRoute />,
        children: protectedRoutes,
      },
    ],
  },
];

export const router = createBrowserRouter(routes);
